import {Alert, Grid, TextField, Typography} from "@mui/material";

const ScheduleInfo = () => (
  <Alert severity="info" sx={{py: 0}}>
    <Typography fontSize={13}>
      <strong>Schedule:</strong> every day from the <strong>start date</strong> to the <strong>end date</strong> (both
      included), the campaign calls its phone numbers, but only between the <strong>start time</strong> and
      the <strong>end time</strong>.
    </Typography>
    <Typography fontSize={13} sx={{mt: 0.5}}>
      <strong>Automatic calling:</strong> every 5 minutes, numbers that are due are queued and called. Each number is
      called <strong>at most once per day</strong>, so retries happen on the following days.
    </Typography>
    <Typography fontSize={13} sx={{mt: 0.5}}>
      <strong>Max attempts:</strong> the maximum number of calls to each phone number. A number keeps
      being called until it answers or the max attempts is reached.
    </Typography>
  </Alert>
);

export const CampaignScheduleFields = ({form, errors, setField}) => {
  return (
    <>
      <Grid item xs={12}>
        <ScheduleInfo/>
      </Grid>
      <Grid item xs={6} md={3}>
        <TextField
          label="Start date" type="date" fullWidth required size="small"
          InputLabelProps={{shrink: true}}
          value={form.startDate} onChange={setField("startDate")}
          helperText="First day of calling"
        />
      </Grid>
      <Grid item xs={6} md={3}>
        <TextField
          label="End date" type="date" fullWidth required size="small"
          InputLabelProps={{shrink: true}}
          inputProps={{min: form.startDate || undefined}}
          value={form.endDate} onChange={setField("endDate")}
          error={!!errors.endDate} helperText={errors.endDate || "Last day of calling"}
        />
      </Grid>
      <Grid item xs={6} md={3}>
        <TextField
          label="Start time" type="time" fullWidth required size="small"
          InputLabelProps={{shrink: true}}
          value={form.startTime} onChange={setField("startTime")}
          helperText="Daily calling starts"
        />
      </Grid>
      <Grid item xs={6} md={3}>
        <TextField
          label="End time" type="time" fullWidth required size="small"
          InputLabelProps={{shrink: true}}
          value={form.endTime} onChange={setField("endTime")}
          error={!!errors.endTime} helperText={errors.endTime || "Daily calling stops"}
        />
      </Grid>
    </>
  )
}
